module.exports = __webpack_public_path__ + "static/img/10008 (4).8a22a3f.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/10000/10008 (4).webp
// module id = TIvb
// module chunks = 14